import styled from '@emotion/styled';
import { mediaMax, spacing } from 'presentations/views/styles';
import ColorButton from 'presentations/views/components/atoms/ColorButton';
import { memo, SyntheticEvent, useMemo } from 'react';
import TextFieldColorPicker from 'presentations/views/components/atoms/TextFieldColorPicker';
import { relativeLuminanceW3C } from 'presentations/views/helpers/color';

interface Props {
  colors: string[];
  color: string;
  onChange?: (e: SyntheticEvent<HTMLButtonElement>) => void;
}

interface OriginalColorProps {
  color: string;
  originalColor: string;
  onChange?: (e: SyntheticEvent<HTMLButtonElement>) => void;
  onChangeOriginalColor: (newValue: string) => void;
}

const Component = memo((props: Props) => {
  const isLightColor = useMemo(() => relativeLuminanceW3C(props.color) >= 0.5, [
    props.color,
  ]);
  return (
    <ColorList>
      {props.colors.map((color) => (
        <ButtonContainer key={color}>
          <ColorButton
            color={color}
            onChange={props.onChange}
            isChecked={color === props.color}
            isLightColor={isLightColor}
          />
        </ButtonContainer>
      ))}
    </ColorList>
  );
});

export const OriginalColorPicker = memo((props: OriginalColorProps) => {
  const isLightColor = useMemo(
    () => relativeLuminanceW3C(props.originalColor) >= 0.5,
    [props.originalColor],
  );
  return (
    <ColorList>
      <OriginalColorButton
        color={props.originalColor}
        onChange={props.onChange}
        isChecked={props.originalColor === props.color}
        isLightColor={isLightColor}
      />
      <TextFieldColorPicker
        value={props.originalColor}
        onChange={props.onChangeOriginalColor}
      />
    </ColorList>
  );
});

const ColorList = styled.div`
  display: flex;
  align-items: center;

  ${mediaMax.tablet} {
    flex-wrap: wrap;
    margin-right: -${spacing(12)};
    margin-bottom: -${spacing(12)};
  }
`;
const ButtonContainer = styled.div`
  margin-right: ${spacing(16)};
  &:last-of-type {
    margin-right: 0;
  }

  ${mediaMax.tablet} {
    margin-right: ${spacing(12)};
    margin-bottom: ${spacing(12)};
    &:last-of-type {
      margin-right: 0;
    }
  }
`;
const OriginalColorButton = styled(ColorButton)`
  margin-right: ${spacing(12)};
`;

export default Component;
